import { styled, Theme, Dialog } from '@material-ui/core'

export const Modal = styled(Dialog)({
  '& .MuiDialog-paperWidthSm': {
    maxWidth: 'unset',
  },
})

export const Wrapper = styled('div')(({ theme }: { theme: Theme }) => ({
  padding: theme.spacing(),
}))

export const ExitButtonContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  '& svg': {
    fontSize: 32,
  },
})
